<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li class="is-active">
          <a href="#" aria-current="page">Pet of the week</a>
        </li>
      </ul>
    </nav>

    <transition name="page">
      <section v-if="loaded">
        <div class="card">
          <div class="card-content">
            <b-field
              grouped
              v-if="pets.length"
              position="is-right">
              <b-select v-model="perPage">
                <option value="5">5 per page</option>
                <option value="10">10 per page</option>
                <option value="15">15 per page</option>
                <option value="20">20 per page</option>
              </b-select>
            </b-field>

            <b-table
              :data="pets"
              :per-page="perPage"
              :loading="isLoading"
              :paginated="!!pets.length"
              :show-detail-icon="true"
              detail-key="id"
              detailed
              hoverable>
              <template slot-scope="props">
                <b-table-column field="user.name" label="User" sortable width="150">
                  {{ props.row.user.name }}
                </b-table-column>

                <b-table-column field="description" label="Description" sortable>
                  {{ props.row.description }}
                </b-table-column>

                <b-table-column field="status" label="Status" sortable>
                  {{ props.row.show ? 'Pet of the week' : '' }}
                </b-table-column>

                <b-table-column field="actions" width="40">
                  <b-dropdown :disabled="props.row.show" position="is-bottom-left">
                    <button class="button is-info" slot="trigger">
                        <b-icon icon="menu-down"></b-icon>
                    </button>

                    <b-dropdown-item has-link>
                      <a @click.prevent.stop="showConfirmation(props.row)">Accept</a> 
                    </b-dropdown-item>
                  </b-dropdown>
                </b-table-column>
              </template>

              <template slot="detail" slot-scope="props">
                <article class="media">
                  <figure class="media-left">
                    <p class="image is-64x64">
                      <img :src="props.row.media_url">
                    </p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>{{ props.row.user.name }}</strong>
                        <small>@{{ props.row.user.nickname }}</small>
                        <small>- {{ props.row.created_at.date | moment('MMMM DD, YYYY') }}</small>
                        <br>
                        {{ props.row.description }}
                      </p>
                    </div>
                  </div>
                </article>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                      </b-icon>
                    </p>
                    <p>Nothing here.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </section>
    </transition>

    <b-modal :active.sync="isConfirmationModalActive" has-modal-card>
      <div class="card">
        <div class="card-content text-center">
          <span class="z-exclamation-outline is-size-2 text-red mb-2"></span>
          <p class="font-medium text-xl">Are you sure you want to set as the pet of the week?</p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item font-bold text-red hover:text-red-light" @click="setPetOfDay">Yes, I'm sure</a>
          <a class="card-footer-item font-bold text-blue hover:text-blue-light" @click="isConfirmationModalActive = false">Cancel</a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'pet-week',
  data: () => ({
    isConfirmationModalActive: false,
    loaded: false,
    perPage: 10,
    selectedPet: {},
  }),
  computed: {
    ...mapState({
      pets: state => state.pets.all,
      petOfToday: state => state.pets.petOfToday,
      isLoading: state => state.pets.isLoading,
    })
  },
  async created() {
    await this.fetch();

    this.loaded = true;
  },
  methods: {
    ...mapActions('pets', ['fetch', 'fetchPetOfToday', 'accept']),

    showConfirmation(post) {
      this.selectedPet = post;
      this.isConfirmationModalActive = true;
    },

    async setPetOfDay() {
      this.isConfirmationModalActive = false;
      await this.accept(this.selectedPet);
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/Pets.vue